import { isErrorWithStatus } from 'src/errors';
import AppError from '../../../errors/AppError';
import ResponseError from '../../../errors/ResponseError';

type WorkspaceData = { name: string, ownerName: string, ownerEmail: string };
export default class InsufficientStorageError extends AppError {
	workspaceData: WorkspaceData;

	constructor( {
		message, cause, workspaceData
	}: {
		message?: string,
		cause?: Error,
		workspaceData: WorkspaceData
	} ) {
		super( { message, cause } );

		this.workspaceData = workspaceData;
	}

	static fromResponseError( error: ResponseError ) {
		const receivedWorkspaceData = (
			error.getMetaField( 'workspace_data' )
		) as { name: string, owner_name: string, owner_email: string };

		const workspaceData = {
			name: receivedWorkspaceData.name,
			ownerName: receivedWorkspaceData.owner_name,
			ownerEmail: receivedWorkspaceData.owner_email
		}

		return new this( {
			message: error.message,
			cause: error,
			workspaceData
		} );
	}
}

export const isInsufficientStorageError = isErrorWithStatus( 400, 'insufficient_storage' );
